import { UserRewardType } from 'v2/constants';

export const SELECT_REWARDS = [UserRewardType.CONTEST_TICKET, UserRewardType.GOLDEN_TICKET];
